import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.sentryEnvironment) {
  Sentry.init({
    dsn: 'https://c90a0c8cb8af47c09b01c540824b1640@o200076.ingest.sentry.io/5607635',
    environment: environment.sentryEnvironment,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

